import { useEffect } from 'react';
import { AppProvider } from './providers';
import { AppRoutes } from '../shared/routes';
import CheckUserProfile from './lib/checkUserProfile';
import { PROJECT_CONFIG } from '@/config/projects';

export const App = () => {
  useEffect(() => {
    const link: HTMLLinkElement | null = document.querySelector('link[rel*="icon"]');
    if (link) {
      link.href = PROJECT_CONFIG.favicon;
    }

    document.title = PROJECT_CONFIG.alt || PROJECT_CONFIG.name;
  }, []);

  return (
    <AppProvider>
      <CheckUserProfile />
      <AppRoutes />
    </AppProvider>
  );
};

export default App;